/** Ajusta a URL informada adicionando o protocolo https:// caso a URL não possuir */
export function ajustarUrl(url: string): string {
    if (!url || url.trim().length === 0) {
        return null;
    }

    // Se o não possuir "http://" e nem "https://", então inserimos...
    if (url.toLowerCase().indexOf('http://') === -1 && url.toLowerCase().indexOf('https://') === -1) {
       return `https://${url}`;
    }

    return url;
}
